import { FETCH_USER, FETCH_PROFILE, EXPORT_USERS_LIST, FETCH_USERS, CREATE_USER, FETCH_USER_LIST, UPDATE_USER, DELETE_USER, USER_ERROR, USER_RESET } from '../actions/types';

const INITIAL_STATE = { profile: {}, user: {}, users: {}, list:{}, authorization: {}, message: '', error: '' };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_USERS:
      return { ...state, users: action.payload.documents, authorization: action.payload.authorization, message:'', error: '' };
    case FETCH_USER:
      return { ...state, user: action.payload.document, authorization: action.payload.authorization , message:'', error: '' };
    case FETCH_USER_LIST:
      return { ...state, list: action.payload.list, authorization: action.payload.authorization , message: '', error: '' };
    case FETCH_PROFILE:
      return { ...state, profile: action.payload, authorization: action.payload.authorization , message:'', error: '' };
    case CREATE_USER:
      return { ...state, message: action.payload.message,authorization: action.payload.authorization, error: action.payload.error ? action.payload.error : '' };
    case UPDATE_USER:
      return { ...state, message: action.payload.message, authorization: action.payload.authorization, error: '' };
    case DELETE_USER:
      return { ...state, message: action.payload.message, authorization: action.payload.authorization, error: '' };
    case EXPORT_USERS_LIST:
      return { ...state, export: action.payload, message: '', error: '' };
    case USER_ERROR:
      return { ...state, authorization: {}, error: action.payload };
    case USER_RESET:
      return INITIAL_STATE;
    default:
      return { ...state}
  }

  //return state;
}
